/* Willy Wolle · Varianten-Karten auf der Produktseite
   - Klick auf eine Karte stellt den ausgeblendeten Theme-„Variant picker“ um.
     Das Theme übernimmt dann wie gewohnt Preis, Bilder, URL und die Variante im Formular.
   - Nach einem Variantenwechsel werden Mengen-Auswahl (Preise, „Versandkostenfrei“),
     Versand-Fortschritt und der Preis im Button auf die neue Variante gesetzt.
   Wird nur auf Produkten mit Varianten geladen (snippets/ww-varianten.liquid). */
(function () {
  'use strict';
  if (window.__wwPdpVarLoaded) return;
  window.__wwPdpVarLoaded = true;

  var SEP = ' · ';

  function fmt(cents) {
    try {
      var s = window.MinimogSettings;
      if (typeof window.formatMoney === 'function' && s && s.money_format) {
        return window.formatMoney(cents, s.money_format);
      }
    } catch (e) { /* Fallback unten */ }
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: cur }).format(cents / 100);
  }

  function rate() {
    var r = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
    return r > 0 ? r : 1;
  }

  function variants() {
    var el = document.querySelector('.main-product [data-variant-picker] #productVariants') ||
      document.querySelector('[data-variant-picker] #productVariants');
    if (!el) return [];
    if (!el.__wwParsed) {
      try { el.__wwParsed = JSON.parse(el.textContent); } catch (e) { el.__wwParsed = []; }
    }
    return el.__wwParsed;
  }

  function markCards(wrap) {
    wrap.querySelectorAll('[data-ww-var-card]').forEach(function (card) {
      var input = card.querySelector('input');
      card.classList.toggle('is-checked', !!(input && input.checked));
    });
  }

  /* Karte gewählt → passendes Feld im Theme-Picker setzen und dessen change auslösen */
  function pick(input) {
    var wrap = input.closest('[data-ww-var]');
    var group = input.closest('[data-ww-var-option]');
    if (!wrap || !group) return;
    markCards(wrap);
    var name = group.getAttribute('data-ww-var-option');
    var value = input.value;
    var box = document.querySelector('[data-variant-picker][data-section="' + wrap.dataset.section + '"]') ||
      document.querySelector('[data-variant-picker]');
    var picker = box && box.querySelector('variant-picker');
    if (!picker) return;
    var fields = picker.querySelectorAll('input[type="radio"], select');
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      if (f.tagName === 'SELECT') {
        if (f.name === 'options[' + name + ']') {
          f.value = value;
          f.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      } else if (f.name === name && f.value === value) {
        f.checked = true;
        f.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }

  /* Mengen-Auswahl und Versand-Fortschritt (assets/ww-pdp.js) neu rechnen lassen */
  function refreshPdp() {
    var q = document.querySelector('[data-ww-qty] input[name="quantity"]:checked');
    if (q) q.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function apply(id) {
    var list = variants();
    var v = null;
    for (var i = 0; i < list.length; i++) if (list[i].id === id) { v = list[i]; break; }
    if (!v) return;

    document.querySelectorAll('[data-ww-var]').forEach(function (wrap) {
      wrap.querySelectorAll('[data-ww-var-option]').forEach(function (group, gi) {
        var val = v.options && v.options[gi];
        group.querySelectorAll('input').forEach(function (inp) { inp.checked = inp.value === val; });
      });
      markCards(wrap);
    });

    var changed = false;
    document.querySelectorAll('[data-ww-qty]').forEach(function (fs) {
      if (fs.dataset.unitPrice === String(v.price)) return;
      changed = true;
      fs.dataset.unitPrice = String(v.price);
      var threshold = Math.round((parseInt(fs.dataset.threshold, 10) || 0) * rate());
      fs.querySelectorAll('[data-ww-qty-option]').forEach(function (opt) {
        var q = parseInt(opt.dataset.qty, 10) || 1;
        var price = opt.querySelector('[data-ww-qty-price]');
        if (price) price.textContent = fmt(v.price * q);
        var tag = opt.querySelector('[data-ww-free-tag]');
        if (tag) tag.hidden = !(threshold > 0 && v.price * q >= threshold);
      });
    });

    document.querySelectorAll('[data-ww-shipbar]').forEach(function (bar) {
      if (bar.dataset.variantId === String(v.id) && bar.dataset.unitPrice === String(v.price)) return;
      changed = true;
      bar.dataset.unitPrice = String(v.price);
      bar.dataset.variantId = String(v.id);
      bar.dataset.inCart = 'false';
    });

    if (changed) refreshPdp();
  }

  /* Das Theme setzt den Button-Text bei Variantenwechsel (und beim Laden) zurück:
     dann den Preis über die Mengen-Auswahl wieder anhängen lassen */
  function watchButton() {
    var fs = document.querySelector('[data-ww-qty]');
    if (!fs || fs.dataset.priceInButton !== 'true' || !window.MutationObserver) return;
    var form = document.getElementById(fs.dataset.formId);
    var btn = form && form.querySelector('[name="add"]');
    var label = btn && btn.querySelector('.atc-text');
    if (!label) return;
    new MutationObserver(function () {
      if (btn.disabled || btn.classList.contains('disabled')) return;
      if (label.textContent.indexOf(SEP) === -1) refreshPdp();
    }).observe(btn, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled'] });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-ww-var] input[type="radio"]')) pick(t);
    else if (t.matches('form [name="id"]')) {
      // erst nach dem Theme-Handler übernehmen (der setzt Preis und Button)
      setTimeout(function () { apply(parseInt(t.value, 10)); }, 0);
    }
  });

  function init() {
    if (!document.querySelector('[data-ww-var]')) return;
    watchButton();
    var idInput = document.querySelector('.main-product__block-buy_buttons form [name="id"]') ||
      document.querySelector('form[data-type="add-to-cart-form"] [name="id"]');
    if (idInput) apply(parseInt(idInput.value, 10));
  }

  window.addEventListener('pageshow', function (e) { if (e.persisted) init(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
